import React from "react";
import PropTypes from "prop-types";
import "../styles/VideoPlayer.scss";

const VideoPlayer = ({ src, poster, title, description }) => {
  return (
    <div className="video-player">
      {title && (
        <div className="video-player__header">
          <h3>{title}</h3>
        </div>
      )}

      <div className="video-player__container">
        <video controls src={src} className="video-player__video" playsInline>
          Your browser does not support the video tag.
        </video>
      </div>

      {description && (
        <div className="video-player__footer">
          <p>{description}</p>
        </div>
      )}
    </div>
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default VideoPlayer;
